/*
 * This is heavily modified from d3-scale time.js
 *
 * According to Bostock, d3 is going to expose some of this for us at some point
 * according to https://github.com/d3/d3-time/issues/8
 *
 * Once that issue is fixed, we can revisit this code
 */
import * as d3Time from 'd3-time'

import * as d3Array from 'd3-array'

const durationSecond = 1000
const durationMinute = durationSecond * 60
const durationHour = durationMinute * 60
const durationDay = durationHour * 24
const durationWeek = durationDay * 7
const durationMonth = durationDay * 30
const durationYear = durationDay * 365

const tickIntervals = [
  [d3Time.timeSecond, 1, durationSecond],
  [d3Time.timeSecond, 5, 5 * durationSecond],
  [d3Time.timeSecond, 15, 15 * durationSecond],
  [d3Time.timeSecond, 30, 30 * durationSecond],
  [d3Time.timeMinute, 1, durationMinute],
  [d3Time.timeMinute, 5, 5 * durationMinute],
  [d3Time.timeMinute, 15, 15 * durationMinute],
  [d3Time.timeMinute, 30, 30 * durationMinute],
  [d3Time.timeHour, 1, durationHour],
  [d3Time.timeHour, 3, 3 * durationHour],
  [d3Time.timeHour, 6, 6 * durationHour],
  [d3Time.timeHour, 12, 12 * durationHour],
  [d3Time.timeDay, 1, durationDay],
  [d3Time.timeDay, 2, 2 * durationDay],
  [d3Time.timeWeek, 1, durationWeek],
  [d3Time.timeMonth, 1, durationMonth],
  [d3Time.timeMonth, 3,  3 * durationMonth],
  [d3Time.timeYear, 1, durationYear]
]

/*
 * Determines a reasonable tick interval based on the extent of the domain
 * (start, stop) and rough estimate of tick size. Returns an object
 * of the `interval` (from d3-time) that should be used for the ticks, and the `step`
 * used between each tick
 */
export default function (interval, start, stop) {
  var target = Math.abs(stop - start) / interval
    , i = d3Array.bisector(_i => _i[2]).right(tickIntervals, target)
    , step = null

  if (i === tickIntervals.length) {
    step = d3Array.tickStep(start / durationYear, stop / durationYear, interval)
    interval = d3Time.timeYear
  } else if (i) {
    i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i]
    step = i[1]
    interval = i[0]
  } else {
    step = Math.max(d3Array.tickStep(start, stop, interval), 1)
    interval = d3Time.timeMillisecond
  }

  return {
    interval: interval,
    step: step
  }
}
